// Accounting › Fixed assets — the asset window, the asset form and its small action dialogs (prefix aw_faa_). Batch 9 R4.
// Rules (as every mt package): no _plural keys; numbers as {{n}}; no empty value in any language.
// The tab names and the six statuses are facommon's (aw_fa_*), reused, never redefined here.
export const en: Record<string, string> = {
  aw_faa_window_title: 'Fixed asset',
  aw_faa_not_found: 'This asset is not on the register (it may have been removed).',
  aw_faa_load_failed: 'Could not load the asset',
  aw_faa_stat_cost: 'Cost',
  aw_faa_stat_accum: 'Accumulated depreciation',
  aw_faa_stat_nbv: 'Net book value',
  aw_faa_sec_fields: 'Register details',
  aw_faa_f_asset_no: 'Asset number',
  aw_faa_f_name: 'Asset name / description',
  aw_faa_f_name_th: 'Name (Thai)',
  aw_faa_f_name_en: 'Name (English)',
  aw_faa_f_category: 'Asset category',
  aw_faa_f_purchase_date: 'Purchase date',
  aw_faa_f_supplier: 'Supplier',
  aw_faa_f_invoice_no: 'Supplier invoice no.',
  aw_faa_f_cost: 'Acquisition cost',
  aw_faa_f_capitalised: 'Capitalised cost',
  aw_faa_f_available_date: 'Available-for-use date',
  aw_faa_f_start_date: 'Depreciation start date',
  aw_faa_f_life: 'Useful life (years)',
  aw_faa_f_rate: 'Depreciation rate (% a year)',
  aw_faa_f_method: 'Depreciation method',
  aw_faa_f_residual: 'Residual value',
  aw_faa_f_accumulated: 'Accumulated depreciation',
  aw_faa_f_nbv: 'Net book value',
  aw_faa_f_location: 'Location / department',
  aw_faa_f_status: 'Asset status',
  aw_faa_f_documents: 'Supporting documents',
  aw_faa_f_note: 'Note',
  aw_faa_f_opening: 'Accumulated depreciation brought forward',
  aw_faa_f_opening_as_of: 'Brought forward to (date)',
  aw_faa_f_other: 'Another field',
  aw_faa_no_category: 'No category — assign one',
  aw_faa_ceiling_short: 'up to {{max}}% a year',
  aw_faa_total_cost: 'Total cost {{amount}}',
  aw_faa_start_is_available: '= the available-for-use date ({{date}})',
  aw_faa_start_is_purchase: '= the purchase date ({{date}})',
  aw_faa_life_years: '{{n}} year(s)',
  aw_faa_rate_pct: '{{n}}% a year',
  aw_faa_not_depreciated: 'Not depreciated — this tax class is not depreciable.',
  aw_faa_method_straight_line: 'Straight-line',
  aw_faa_docs_n: '{{n}} document(s)',
  aw_faa_hand: 'set by hand',
  aw_faa_hand_title: 'This asset holds its own setting here, not its category\'s.',
  aw_faa_hand_note: 'Settings marked "set by hand" differ from the asset\'s category and were chosen for this asset alone.',
  aw_faa_sec_accounts: 'Accounts',
  aw_faa_acct_asset: 'Asset account',
  aw_faa_acct_accum: 'Accumulated depreciation account',
  aw_faa_acct_expense: 'Depreciation expense account',
  aw_faa_acct_unknown: 'an account no longer in the chart',
  aw_faa_cat_unknown: 'a category no longer listed',
  aw_faa_opening_line: '{{amount}} brought forward, running to {{date}}',
  aw_faa_opening_nbv: 'Opening net book value {{amount}} — the total cost less what was brought forward.',
  aw_faa_f_frequency: 'Depreciation frequency',
  aw_faa_freq_company: 'The company\'s setting — the same for every asset.',
  aw_faa_nbv_at_disposal: 'Book value at disposal {{amount}}',
  aw_faa_removed_banner: 'Removed from the register by {{by}} on {{when}}. It is shown here read-only, with its history — nothing on it can be changed.',
  aw_faa_source_label: 'Where it came from:',
  aw_faa_source_link: 'Bought on {{doc}} line {{n}}',
  aw_faa_source_amount: '{{amount}} of that line',
  aw_faa_sec_charges: 'Depreciation charged',
  aw_faa_charges_none: 'Nothing has been charged on this asset yet.',
  aw_faa_ch_window: 'Period',
  aw_faa_ch_days: 'Days',
  aw_faa_ch_amount: 'Amount',
  aw_faa_ch_entry: 'Entry',
  aw_faa_ch_total: 'Total charged',
  aw_faa_entry_draft: 'Draft',
  aw_faa_entry_posted: 'Posted',
  aw_faa_entry_missing: 'Entry missing',
  aw_faa_disposed_on: 'Disposed of on {{date}}',
  aw_faa_proceeds: 'Proceeds {{amount}}',
  aw_faa_disposal_entry: 'Disposal entry {{no}}',
  aw_faa_sec_history: 'History',
  aw_faa_history_none: 'No history recorded yet.',
  aw_faa_mv_registered: 'Registered',
  aw_faa_mv_registered_from: 'from the expense record, line {{n}}',
  aw_faa_mv_edit: 'Changed',
  aw_faa_mv_disposed: 'Disposed of',
  aw_faa_mv_written_off: 'Written off',
  aw_faa_mv_disposal_discarded: 'Disposal draft discarded',
  aw_faa_mv_reversed: 'Entry reversed',
  aw_faa_mv_file_added: 'Document added',
  aw_faa_mv_file_removed: 'Document removed',
  aw_faa_mv_deleted: 'Removed from the register',
  aw_faa_mv_other: 'Recorded',
  aw_faa_on_date: 'on {{date}}',
  aw_faa_audit_created: 'Registered by {{by}} · {{when}}',
  aw_faa_audit_updated: 'last changed by {{by}} · {{when}}',
  aw_faa_sec_documents: 'Supporting documents',
  aw_faa_docs_none: 'No documents attached.',
  aw_faa_doc_open: 'Open the document',
  aw_faa_doc_remove: 'Remove',
  aw_faa_doc_remove_confirm: 'Remove "{{name}}" from this asset? Its history will still say it was attached.',
  aw_faa_doc_upload: 'Attach a document',
  aw_faa_doc_types: 'PDF, photo (JPEG, PNG, WebP, HEIC), Excel or Word — up to 15 MB.',
  aw_faa_act_edit: 'Edit',
  aw_faa_act_dispose: 'Dispose',
  aw_faa_act_writeoff: 'Write off',
  aw_faa_act_delete: 'Delete',
  aw_faa_disposed_msg: 'Disposal recorded.',
  aw_faa_writtenoff_msg: 'Write-off recorded.',
  aw_faa_draft_made: 'A DRAFT journal entry {{no}} was made. It reaches the ledger only once it is posted under Accounting › Journal entries.',
  aw_faa_gain: 'Gain on disposal: {{amount}}',
  aw_faa_loss: 'Loss: {{amount}}',
  aw_faa_open_journal: 'Open Journal entries',
  aw_faa_act_nbv: 'Net book value today: {{amount}}',
  aw_faa_act_date: 'Date',
  aw_faa_act_note: 'Note',
  aw_faa_choose: '— choose —',
  aw_faa_dispose_title: 'Dispose of the asset',
  aw_faa_dispose_btn: 'Dispose',
  aw_faa_dispose_proceeds: 'Proceeds received (0 if none)',
  aw_faa_dispose_proceeds_acct: 'Received into (account)',
  aw_faa_dispose_gl_acct: 'Gain or loss account',
  aw_faa_dispose_hint: 'Cost and accumulated depreciation come out, the proceeds go in, and the difference is the gain or loss. This makes a DRAFT entry, to be posted under Journal entries.',
  aw_faa_writeoff_title: 'Write the asset off',
  aw_faa_writeoff_btn: 'Write off',
  aw_faa_writeoff_acct: 'Loss account (expense)',
  aw_faa_writeoff_hint: 'The asset is gone and nothing was received: its net book value becomes a loss. This makes a DRAFT entry, to be posted under Journal entries.',
  aw_faa_delete_title: 'Delete the asset',
  aw_faa_delete_btn: 'Delete',
  aw_faa_delete_reason: 'Reason',
  aw_faa_delete_hint: 'Only for an asset registered by mistake. It leaves the register; its history keeps who removed it and why.',
  aw_faa_form_new_title: 'Register a fixed asset',
  aw_faa_form_src_title: 'Register a fixed asset from an expense',
  aw_faa_form_edit_title: 'Edit fixed asset',
  aw_faa_form_readonly: 'This login reads the register; it cannot change it.',
  aw_faa_register_btn: 'Register',
  aw_faa_save_btn: 'Save',
  aw_faa_disposed_no_edit: 'This asset was disposed of on {{date}} and can no longer be edited. Reverse the disposal entry first, or discard its draft.',
  aw_faa_locked_why: 'Depreciation has already been charged on this asset, and every charge was computed from its figures, dates, accounts and category — so those are locked. Names, supplier, invoice no., location, status and note can still be changed.',
  aw_faa_sec_asset: 'The asset',
  aw_faa_sec_purchase: 'Purchase and cost',
  aw_faa_sec_depreciation: 'Depreciation',
  aw_faa_sec_opening: 'Brought forward from before this system',
  aw_faa_sec_where: 'Location and status',
  aw_faa_choose_category: '— choose a category —',
  aw_faa_category_hint: 'The category supplies the tax class, rate, method and the three accounts.',
  aw_faa_category_required: 'Choose the asset category first — every asset belongs to one.',
  aw_faa_no_categories: 'This company has no active asset category yet — add one under Asset Categories.',
  aw_faa_class_line: 'Tax class: {{cls}} · up to {{max}}% a year',
  aw_faa_class_not_dep: 'Tax class: {{cls}} — not depreciated',
  aw_faa_cat_matching: 'Keeping assets in {{code}}, the purchase\'s account',
  aw_faa_cat_others: 'Other categories',
  aw_faa_cat_none_matching: 'No category keeps its assets in {{code}}. Add one under Asset Categories, or set the asset account to {{code}} by hand.',
  aw_faa_cat_account: 'Category: {{acct}}',
  aw_faa_capitalised_hint: 'Delivery, installation and similar costs added on top of the purchase price.',
  aw_faa_start_hint: 'Blank = the available-for-use date, or else the purchase date.',
  aw_faa_life_hint: 'Life and rate are one setting: 5 years = 20% a year.',
  aw_faa_ceiling: 'The decree allows at most {{max}}% a year for {{cls}}.',
  aw_faa_method_hint: 'Straight-line only, for now.',
  aw_faa_opening_hint: 'For an asset brought in part-way through its life: give both the amount and the date it runs to, or neither.',
  aw_faa_opening_both: 'Give both the amount brought forward and the date it runs to — or neither.',
  aw_faa_status_auto: 'Worked out from the dates',
  aw_faa_status_hint: 'Fully depreciated, disposed and written off are worked out from the figures and cannot be chosen.',
  aw_faa_accounts_hint: 'Taken from the category. A different account for this one asset is marked "set by hand".',
  aw_faa_src_title: 'Bought on this expense record',
  aw_faa_src_no: 'Expense no.',
  aw_faa_src_date: 'Date',
  aw_faa_src_pick: 'Choose',
  aw_faa_src_line: 'Line',
  aw_faa_src_line_n: 'Line {{n}}',
  aw_faa_src_desc: 'Description',
  aw_faa_src_account: 'Account',
  aw_faa_src_amount: 'Amount',
  aw_faa_src_registered: 'Already registered',
  aw_faa_src_remaining: 'Remaining',
  aw_faa_src_hint: 'Choose the line the asset was bought on. Registering posts nothing — the purchase entry already is the acquisition.',
  aw_faa_src_acct_differs: 'This category puts the asset in {{have}}, but the purchase put its cost in {{code}} {{name}} — the register will refuse it. Choose a category whose asset account is {{code}}.',
  aw_faa_src_acct_hand: 'The asset account is set to {{have}}, but the purchase put its cost in {{code}} {{name}} — the register will refuse it. Set the asset account to {{code}}.',
  aw_faa_src_acct_kept: 'Bought on an expense record — the asset stays in the account the purchase put its cost in.',
  aw_faa_src_acct_moved: 'The purchase line is now booked to {{code}} {{name}} — saving moves the asset there from {{was}}, so the register and the ledger agree.',
  aw_faa_src_cost_over: 'Line {{n}} of the purchase holds {{amount}}; with the other assets bought on it, this asset can cost at most {{max}}.',
  aw_faa_src_line_gone: 'The purchase line this asset was bought on is gone, or no longer booked to an asset account — its cost and asset account stay as registered until the bill is put right.',
};
export const zh: Record<string, string> = {
  aw_faa_window_title: '固定资产',
  aw_faa_not_found: '登记簿上没有这项资产（可能已被删除）。',
  aw_faa_load_failed: '无法读取该资产',
  aw_faa_stat_cost: '成本',
  aw_faa_stat_accum: '累计折旧',
  aw_faa_stat_nbv: '账面净值',
  aw_faa_sec_fields: '登记信息',
  aw_faa_f_asset_no: '资产编号',
  aw_faa_f_name: '资产名称 / 描述',
  aw_faa_f_name_th: '名称（泰文）',
  aw_faa_f_name_en: '名称（英文）',
  aw_faa_f_category: '资产类别',
  aw_faa_f_purchase_date: '购买日期',
  aw_faa_f_supplier: '供应商',
  aw_faa_f_invoice_no: '供应商发票号',
  aw_faa_f_cost: '购置成本',
  aw_faa_f_capitalised: '资本化成本',
  aw_faa_f_available_date: '可供使用日期',
  aw_faa_f_start_date: '折旧开始日期',
  aw_faa_f_life: '使用年限（年）',
  aw_faa_f_rate: '折旧率（每年 %）',
  aw_faa_f_method: '折旧方法',
  aw_faa_f_residual: '残值',
  aw_faa_f_accumulated: '累计折旧',
  aw_faa_f_nbv: '账面净值',
  aw_faa_f_location: '存放地点 / 部门',
  aw_faa_f_status: '资产状态',
  aw_faa_f_documents: '附件凭证',
  aw_faa_f_note: '备注',
  aw_faa_f_opening: '期初累计折旧（结转）',
  aw_faa_f_opening_as_of: '结转截至日期',
  aw_faa_f_other: '其他字段',
  aw_faa_no_category: '未分类 — 请指定类别',
  aw_faa_ceiling_short: '每年最高 {{max}}%',
  aw_faa_total_cost: '合计成本 {{amount}}',
  aw_faa_start_is_available: '= 可供使用日期（{{date}}）',
  aw_faa_start_is_purchase: '= 购买日期（{{date}}）',
  aw_faa_life_years: '{{n}} 年',
  aw_faa_rate_pct: '每年 {{n}}%',
  aw_faa_not_depreciated: '不计提折旧 — 该税法类别不可折旧。',
  aw_faa_method_straight_line: '直线法',
  aw_faa_docs_n: '{{n}} 份文件',
  aw_faa_hand: '手工设置',
  aw_faa_hand_title: '此项为该资产自己的设置，而非其类别的设置。',
  aw_faa_hand_note: '标有“手工设置”的项与资产类别不同，是为这一项资产单独选择的。',
  aw_faa_sec_accounts: '会计科目',
  aw_faa_acct_asset: '资产科目',
  aw_faa_acct_accum: '累计折旧科目',
  aw_faa_acct_expense: '折旧费用科目',
  aw_faa_acct_unknown: '已不在科目表中的科目',
  aw_faa_cat_unknown: '已不在列表中的类别',
  aw_faa_opening_line: '结转 {{amount}}，截至 {{date}}',
  aw_faa_opening_nbv: '期初账面净值 {{amount}} — 即总成本减去结转的累计折旧。',
  aw_faa_f_frequency: '折旧频率',
  aw_faa_freq_company: '公司设置 — 所有资产相同。',
  aw_faa_nbv_at_disposal: '处置时账面价值 {{amount}}',
  aw_faa_removed_banner: '已由 {{by}} 于 {{when}} 从登记簿中删除。此处只读显示，并保留其历史记录 — 不能再作任何更改。',
  aw_faa_source_label: '来源：',
  aw_faa_source_link: '购于 {{doc}} 第 {{n}} 行',
  aw_faa_source_amount: '占该行 {{amount}}',
  aw_faa_sec_charges: '已计提折旧',
  aw_faa_charges_none: '该资产尚未计提任何折旧。',
  aw_faa_ch_window: '期间',
  aw_faa_ch_days: '天数',
  aw_faa_ch_amount: '金额',
  aw_faa_ch_entry: '凭证',
  aw_faa_ch_total: '累计已计提',
  aw_faa_entry_draft: '草稿',
  aw_faa_entry_posted: '已过账',
  aw_faa_entry_missing: '凭证缺失',
  aw_faa_disposed_on: '于 {{date}} 处置',
  aw_faa_proceeds: '处置收入 {{amount}}',
  aw_faa_disposal_entry: '处置凭证 {{no}}',
  aw_faa_sec_history: '变动记录',
  aw_faa_history_none: '暂无变动记录。',
  aw_faa_mv_registered: '登记',
  aw_faa_mv_registered_from: '来自费用记录第 {{n}} 行',
  aw_faa_mv_edit: '修改',
  aw_faa_mv_disposed: '处置',
  aw_faa_mv_written_off: '核销',
  aw_faa_mv_disposal_discarded: '处置草稿已作废',
  aw_faa_mv_reversed: '凭证已冲销',
  aw_faa_mv_file_added: '添加文件',
  aw_faa_mv_file_removed: '移除文件',
  aw_faa_mv_deleted: '从登记簿中删除',
  aw_faa_mv_other: '记录',
  aw_faa_on_date: '日期 {{date}}',
  aw_faa_audit_created: '由 {{by}} 登记 · {{when}}',
  aw_faa_audit_updated: '最近由 {{by}} 修改 · {{when}}',
  aw_faa_sec_documents: '附件凭证',
  aw_faa_docs_none: '尚无附件。',
  aw_faa_doc_open: '打开文件',
  aw_faa_doc_remove: '移除',
  aw_faa_doc_remove_confirm: '从该资产移除“{{name}}”？变动记录仍会保留曾附上此文件。',
  aw_faa_doc_upload: '添加附件',
  aw_faa_doc_types: 'PDF、照片（JPEG、PNG、WebP、HEIC）、Excel 或 Word — 不超过 15 MB。',
  aw_faa_act_edit: '编辑',
  aw_faa_act_dispose: '处置',
  aw_faa_act_writeoff: '核销',
  aw_faa_act_delete: '删除',
  aw_faa_disposed_msg: '处置已记录。',
  aw_faa_writtenoff_msg: '核销已记录。',
  aw_faa_draft_made: '已生成草稿凭证 {{no}}。须在 会计 › 记账凭证 中过账后才会进入总账。',
  aw_faa_gain: '处置收益：{{amount}}',
  aw_faa_loss: '损失：{{amount}}',
  aw_faa_open_journal: '打开记账凭证',
  aw_faa_act_nbv: '当前账面净值：{{amount}}',
  aw_faa_act_date: '日期',
  aw_faa_act_note: '备注',
  aw_faa_choose: '— 请选择 —',
  aw_faa_dispose_title: '处置资产',
  aw_faa_dispose_btn: '处置',
  aw_faa_dispose_proceeds: '处置收入（没有则填 0）',
  aw_faa_dispose_proceeds_acct: '收款科目',
  aw_faa_dispose_gl_acct: '处置损益科目',
  aw_faa_dispose_hint: '转出成本和累计折旧，转入处置收入，差额即处置损益。此操作生成一张草稿凭证，须在记账凭证中过账。',
  aw_faa_writeoff_title: '核销资产',
  aw_faa_writeoff_btn: '核销',
  aw_faa_writeoff_acct: '损失科目（费用类）',
  aw_faa_writeoff_hint: '资产已灭失且无任何收入：其账面净值转为损失。此操作生成一张草稿凭证，须在记账凭证中过账。',
  aw_faa_delete_title: '删除资产',
  aw_faa_delete_btn: '删除',
  aw_faa_delete_reason: '原因',
  aw_faa_delete_hint: '仅用于误登记的资产。资产将移出登记簿；变动记录会保留删除人和原因。',
  aw_faa_form_new_title: '登记固定资产',
  aw_faa_form_src_title: '从费用记录登记固定资产',
  aw_faa_form_edit_title: '编辑固定资产',
  aw_faa_form_readonly: '此登录只能查看登记簿，不能修改。',
  aw_faa_register_btn: '登记',
  aw_faa_save_btn: '保存',
  aw_faa_disposed_no_edit: '该资产已于 {{date}} 处置，不能再编辑。请先冲销处置凭证，或作废其草稿。',
  aw_faa_locked_why: '该资产已计提折旧，每一笔折旧都是按其金额、日期、科目和类别计算的，因此这些字段已锁定。名称、供应商、发票号、存放地点、状态和备注仍可修改。',
  aw_faa_sec_asset: '资产',
  aw_faa_sec_purchase: '购置与成本',
  aw_faa_sec_depreciation: '折旧',
  aw_faa_sec_opening: '系统启用前的结转数',
  aw_faa_sec_where: '地点与状态',
  aw_faa_choose_category: '— 请选择类别 —',
  aw_faa_category_hint: '类别决定税法类别、折旧率、折旧方法和三个科目。',
  aw_faa_category_required: '请先选择资产类别 — 每项资产都必须属于一个类别。',
  aw_faa_no_categories: '该公司尚无启用的资产类别 — 请在“资产类别”中添加。',
  aw_faa_class_line: '税法类别：{{cls}} · 每年最高 {{max}}%',
  aw_faa_class_not_dep: '税法类别：{{cls}} — 不计提折旧',
  aw_faa_cat_matching: '资产记在 {{code}}（采购所用科目）的类别',
  aw_faa_cat_others: '其他类别',
  aw_faa_cat_none_matching: '没有类别把资产记在 {{code}}。请在“资产类别”中添加，或手工把资产科目设为 {{code}}。',
  aw_faa_cat_account: '类别科目：{{acct}}',
  aw_faa_capitalised_hint: '在购买价格之外计入资产的运费、安装费等。',
  aw_faa_start_hint: '留空 = 可供使用日期，否则为购买日期。',
  aw_faa_life_hint: '年限与折旧率是同一设置：5 年 = 每年 20%。',
  aw_faa_ceiling: '法令规定 {{cls}} 每年最高 {{max}}%。',
  aw_faa_method_hint: '目前仅支持直线法。',
  aw_faa_opening_hint: '用于使用中途转入的资产：金额和截至日期要么都填，要么都不填。',
  aw_faa_opening_both: '结转金额和截至日期须同时填写，或都不填。',
  aw_faa_status_auto: '按日期自动判断',
  aw_faa_status_hint: '已提足折旧、已处置和已核销由数字计算得出，不能手工选择。',
  aw_faa_accounts_hint: '取自类别。若为这一项资产另选科目，会标记为“手工设置”。',
  aw_faa_src_title: '购于此费用记录',
  aw_faa_src_no: '费用编号',
  aw_faa_src_date: '日期',
  aw_faa_src_pick: '选择',
  aw_faa_src_line: '行',
  aw_faa_src_line_n: '第 {{n}} 行',
  aw_faa_src_desc: '描述',
  aw_faa_src_account: '科目',
  aw_faa_src_amount: '金额',
  aw_faa_src_registered: '已登记',
  aw_faa_src_remaining: '剩余',
  aw_faa_src_hint: '请选择购买该资产的那一行。登记不会生成任何凭证 — 采购凭证本身就是购置记录。',
  aw_faa_src_acct_differs: '此类别会把资产记在 {{have}}，但采购把成本记在 {{code}} {{name}} — 登记会被拒绝。请选择资产科目为 {{code}} 的类别。',
  aw_faa_src_acct_hand: '资产科目现为 {{have}}，但采购把成本记在 {{code}} {{name}} — 登记会被拒绝。请把资产科目设为 {{code}}。',
  aw_faa_src_acct_kept: '购于费用记录 — 资产须留在采购记入成本的科目。',
  aw_faa_src_acct_moved: '该采购行现已记入 {{code}} {{name}} — 保存后资产将从 {{was}} 转入该科目，使登记簿与总账一致。',
  aw_faa_src_cost_over: '采购第 {{n}} 行金额为 {{amount}}；扣除该行已登记的其他资产后，此资产的成本最多为 {{max}}。',
  aw_faa_src_line_gone: '购买此资产的采购行已不存在，或已不再记入资产科目 — 在账单更正之前，其成本和资产科目保持登记时的值。',
};
export const th: Record<string, string> = {
  aw_faa_window_title: 'สินทรัพย์ถาวร',
  aw_faa_not_found: 'ไม่พบสินทรัพย์นี้ในทะเบียน (อาจถูกลบไปแล้ว)',
  aw_faa_load_failed: 'โหลดข้อมูลสินทรัพย์ไม่สำเร็จ',
  aw_faa_stat_cost: 'ราคาทุน',
  aw_faa_stat_accum: 'ค่าเสื่อมราคาสะสม',
  aw_faa_stat_nbv: 'มูลค่าสุทธิตามบัญชี',
  aw_faa_sec_fields: 'ข้อมูลในทะเบียน',
  aw_faa_f_asset_no: 'เลขที่สินทรัพย์',
  aw_faa_f_name: 'ชื่อ / รายละเอียดสินทรัพย์',
  aw_faa_f_name_th: 'ชื่อ (ภาษาไทย)',
  aw_faa_f_name_en: 'ชื่อ (ภาษาอังกฤษ)',
  aw_faa_f_category: 'หมวดสินทรัพย์',
  aw_faa_f_purchase_date: 'วันที่ซื้อ',
  aw_faa_f_supplier: 'ผู้ขาย',
  aw_faa_f_invoice_no: 'เลขที่ใบกำกับของผู้ขาย',
  aw_faa_f_cost: 'ราคาทุนที่ได้มา',
  aw_faa_f_capitalised: 'ต้นทุนที่บันทึกเพิ่ม',
  aw_faa_f_available_date: 'วันที่พร้อมใช้งาน',
  aw_faa_f_start_date: 'วันเริ่มคิดค่าเสื่อมราคา',
  aw_faa_f_life: 'อายุการใช้งาน (ปี)',
  aw_faa_f_rate: 'อัตราค่าเสื่อมราคา (% ต่อปี)',
  aw_faa_f_method: 'วิธีคิดค่าเสื่อมราคา',
  aw_faa_f_residual: 'มูลค่าซาก',
  aw_faa_f_accumulated: 'ค่าเสื่อมราคาสะสม',
  aw_faa_f_nbv: 'มูลค่าสุทธิตามบัญชี',
  aw_faa_f_location: 'สถานที่ / แผนก',
  aw_faa_f_status: 'สถานะสินทรัพย์',
  aw_faa_f_documents: 'เอกสารประกอบ',
  aw_faa_f_note: 'หมายเหตุ',
  aw_faa_f_opening: 'ค่าเสื่อมราคาสะสมยกมา',
  aw_faa_f_opening_as_of: 'ยกมาถึงวันที่',
  aw_faa_f_other: 'ช่องอื่น',
  aw_faa_no_category: 'ยังไม่มีหมวด — โปรดกำหนด',
  aw_faa_ceiling_short: 'สูงสุด {{max}}% ต่อปี',
  aw_faa_total_cost: 'มูลค่ารวม {{amount}}',
  aw_faa_start_is_available: '= วันที่พร้อมใช้งาน ({{date}})',
  aw_faa_start_is_purchase: '= วันที่ซื้อ ({{date}})',
  aw_faa_life_years: '{{n}} ปี',
  aw_faa_rate_pct: '{{n}}% ต่อปี',
  aw_faa_not_depreciated: 'ไม่คิดค่าเสื่อมราคา — ประเภทตามกฎหมายนี้ไม่คิดค่าเสื่อม',
  aw_faa_method_straight_line: 'วิธีเส้นตรง',
  aw_faa_docs_n: '{{n}} ไฟล์',
  aw_faa_hand: 'กำหนดเอง',
  aw_faa_hand_title: 'สินทรัพย์นี้ใช้ค่าที่กำหนดเอง ไม่ใช่ค่าของหมวด',
  aw_faa_hand_note: 'ค่าที่มีป้าย "กำหนดเอง" ต่างจากหมวดของสินทรัพย์ และเลือกไว้สำหรับสินทรัพย์นี้เท่านั้น',
  aw_faa_sec_accounts: 'บัญชี',
  aw_faa_acct_asset: 'บัญชีสินทรัพย์',
  aw_faa_acct_accum: 'บัญชีค่าเสื่อมราคาสะสม',
  aw_faa_acct_expense: 'บัญชีค่าเสื่อมราคา (ค่าใช้จ่าย)',
  aw_faa_acct_unknown: 'บัญชีที่ไม่อยู่ในผังบัญชีแล้ว',
  aw_faa_cat_unknown: 'หมวดที่ไม่อยู่ในรายการแล้ว',
  aw_faa_opening_line: 'ยกมา {{amount}} ถึงวันที่ {{date}}',
  aw_faa_opening_nbv: 'มูลค่าสุทธิตามบัญชียกมา {{amount}} — คือต้นทุนรวมหักค่าเสื่อมราคาสะสมที่ยกมา',
  aw_faa_f_frequency: 'ความถี่การคิดค่าเสื่อมราคา',
  aw_faa_freq_company: 'ตั้งค่าของบริษัท — ใช้เหมือนกันกับสินทรัพย์ทุกรายการ',
  aw_faa_nbv_at_disposal: 'มูลค่าตามบัญชี ณ วันจำหน่าย {{amount}}',
  aw_faa_removed_banner: 'ลบออกจากทะเบียนโดย {{by}} เมื่อ {{when}} แสดงไว้ที่นี่แบบอ่านอย่างเดียวพร้อมประวัติ — แก้ไขสิ่งใดไม่ได้อีก',
  aw_faa_source_label: 'ที่มา:',
  aw_faa_source_link: 'ซื้อตาม {{doc}} บรรทัดที่ {{n}}',
  aw_faa_source_amount: '{{amount}} ของบรรทัดนั้น',
  aw_faa_sec_charges: 'ค่าเสื่อมราคาที่บันทึกแล้ว',
  aw_faa_charges_none: 'ยังไม่มีการคิดค่าเสื่อมราคาของสินทรัพย์นี้',
  aw_faa_ch_window: 'ช่วงเวลา',
  aw_faa_ch_days: 'จำนวนวัน',
  aw_faa_ch_amount: 'จำนวนเงิน',
  aw_faa_ch_entry: 'รายการบัญชี',
  aw_faa_ch_total: 'รวมที่บันทึกแล้ว',
  aw_faa_entry_draft: 'ฉบับร่าง',
  aw_faa_entry_posted: 'ลงบัญชีแล้ว',
  aw_faa_entry_missing: 'ไม่พบรายการบัญชี',
  aw_faa_disposed_on: 'จำหน่ายเมื่อ {{date}}',
  aw_faa_proceeds: 'เงินที่ได้รับ {{amount}}',
  aw_faa_disposal_entry: 'รายการจำหน่าย {{no}}',
  aw_faa_sec_history: 'ประวัติ',
  aw_faa_history_none: 'ยังไม่มีประวัติ',
  aw_faa_mv_registered: 'ลงทะเบียน',
  aw_faa_mv_registered_from: 'จากรายการค่าใช้จ่าย บรรทัดที่ {{n}}',
  aw_faa_mv_edit: 'แก้ไข',
  aw_faa_mv_disposed: 'จำหน่าย',
  aw_faa_mv_written_off: 'ตัดจำหน่าย',
  aw_faa_mv_disposal_discarded: 'ยกเลิกร่างรายการจำหน่าย',
  aw_faa_mv_reversed: 'กลับรายการบัญชี',
  aw_faa_mv_file_added: 'แนบเอกสาร',
  aw_faa_mv_file_removed: 'นำเอกสารออก',
  aw_faa_mv_deleted: 'ลบออกจากทะเบียน',
  aw_faa_mv_other: 'บันทึก',
  aw_faa_on_date: 'วันที่ {{date}}',
  aw_faa_audit_created: 'ลงทะเบียนโดย {{by}} · {{when}}',
  aw_faa_audit_updated: 'แก้ไขล่าสุดโดย {{by}} · {{when}}',
  aw_faa_sec_documents: 'เอกสารประกอบ',
  aw_faa_docs_none: 'ยังไม่มีเอกสารแนบ',
  aw_faa_doc_open: 'เปิดเอกสาร',
  aw_faa_doc_remove: 'นำออก',
  aw_faa_doc_remove_confirm: 'นำ "{{name}}" ออกจากสินทรัพย์นี้หรือไม่? ประวัติจะยังบันทึกว่าเคยแนบไว้',
  aw_faa_doc_upload: 'แนบเอกสาร',
  aw_faa_doc_types: 'PDF รูปภาพ (JPEG, PNG, WebP, HEIC) Excel หรือ Word — ไม่เกิน 15 MB',
  aw_faa_act_edit: 'แก้ไข',
  aw_faa_act_dispose: 'จำหน่าย',
  aw_faa_act_writeoff: 'ตัดจำหน่าย',
  aw_faa_act_delete: 'ลบ',
  aw_faa_disposed_msg: 'บันทึกการจำหน่ายแล้ว',
  aw_faa_writtenoff_msg: 'บันทึกการตัดจำหน่ายแล้ว',
  aw_faa_draft_made: 'สร้างรายการบัญชีฉบับร่าง {{no}} แล้ว จะเข้าบัญชีแยกประเภทเมื่อลงบัญชีที่ บัญชี › สมุดรายวัน เท่านั้น',
  aw_faa_gain: 'กำไรจากการจำหน่าย: {{amount}}',
  aw_faa_loss: 'ขาดทุน: {{amount}}',
  aw_faa_open_journal: 'เปิดสมุดรายวัน',
  aw_faa_act_nbv: 'มูลค่าสุทธิตามบัญชีวันนี้: {{amount}}',
  aw_faa_act_date: 'วันที่',
  aw_faa_act_note: 'หมายเหตุ',
  aw_faa_choose: '— เลือก —',
  aw_faa_dispose_title: 'จำหน่ายสินทรัพย์',
  aw_faa_dispose_btn: 'จำหน่าย',
  aw_faa_dispose_proceeds: 'เงินที่ได้รับ (ใส่ 0 ถ้าไม่มี)',
  aw_faa_dispose_proceeds_acct: 'รับเงินเข้าบัญชี',
  aw_faa_dispose_gl_acct: 'บัญชีกำไรหรือขาดทุน',
  aw_faa_dispose_hint: 'ตัดราคาทุนและค่าเสื่อมราคาสะสมออก บันทึกเงินที่ได้รับ ส่วนต่างคือกำไรหรือขาดทุน รายการนี้เป็นฉบับร่าง ต้องลงบัญชีที่สมุดรายวัน',
  aw_faa_writeoff_title: 'ตัดจำหน่ายสินทรัพย์',
  aw_faa_writeoff_btn: 'ตัดจำหน่าย',
  aw_faa_writeoff_acct: 'บัญชีขาดทุน (ค่าใช้จ่าย)',
  aw_faa_writeoff_hint: 'สินทรัพย์สูญหายและไม่ได้รับเงิน มูลค่าสุทธิตามบัญชีจะเป็นขาดทุน รายการนี้เป็นฉบับร่าง ต้องลงบัญชีที่สมุดรายวัน',
  aw_faa_delete_title: 'ลบสินทรัพย์',
  aw_faa_delete_btn: 'ลบ',
  aw_faa_delete_reason: 'เหตุผล',
  aw_faa_delete_hint: 'ใช้เฉพาะสินทรัพย์ที่ลงทะเบียนผิดพลาด จะถูกนำออกจากทะเบียน โดยประวัติยังเก็บผู้ลบและเหตุผลไว้',
  aw_faa_form_new_title: 'ลงทะเบียนสินทรัพย์ถาวร',
  aw_faa_form_src_title: 'ลงทะเบียนสินทรัพย์ถาวรจากค่าใช้จ่าย',
  aw_faa_form_edit_title: 'แก้ไขสินทรัพย์ถาวร',
  aw_faa_form_readonly: 'ผู้ใช้นี้ดูทะเบียนได้อย่างเดียว แก้ไขไม่ได้',
  aw_faa_register_btn: 'ลงทะเบียน',
  aw_faa_save_btn: 'บันทึก',
  aw_faa_disposed_no_edit: 'สินทรัพย์นี้จำหน่ายแล้วเมื่อ {{date}} จึงแก้ไขไม่ได้ ต้องกลับรายการจำหน่ายก่อน หรือยกเลิกฉบับร่าง',
  aw_faa_locked_why: 'สินทรัพย์นี้มีการคิดค่าเสื่อมราคาแล้ว และทุกรายการคำนวณจากจำนวนเงิน วันที่ บัญชี และหมวดของมัน ช่องเหล่านี้จึงถูกล็อก ส่วนชื่อ ผู้ขาย เลขที่ใบกำกับ สถานที่ สถานะ และหมายเหตุยังแก้ไขได้',
  aw_faa_sec_asset: 'สินทรัพย์',
  aw_faa_sec_purchase: 'การซื้อและราคาทุน',
  aw_faa_sec_depreciation: 'ค่าเสื่อมราคา',
  aw_faa_sec_opening: 'ยอดยกมาก่อนเริ่มใช้ระบบ',
  aw_faa_sec_where: 'สถานที่และสถานะ',
  aw_faa_choose_category: '— เลือกหมวด —',
  aw_faa_category_hint: 'หมวดกำหนดประเภทตามกฎหมาย อัตรา วิธีคิด และบัญชีทั้งสาม',
  aw_faa_category_required: 'เลือกหมวดสินทรัพย์ก่อน — สินทรัพย์ทุกรายการต้องอยู่ในหมวด',
  aw_faa_no_categories: 'บริษัทนี้ยังไม่มีหมวดสินทรัพย์ที่ใช้งาน — เพิ่มได้ที่หมวดสินทรัพย์',
  aw_faa_class_line: 'ประเภทตามกฎหมาย: {{cls}} · สูงสุด {{max}}% ต่อปี',
  aw_faa_class_not_dep: 'ประเภทตามกฎหมาย: {{cls}} — ไม่คิดค่าเสื่อม',
  aw_faa_cat_matching: 'หมวดที่บันทึกสินทรัพย์ใน {{code}} (บัญชีของการซื้อ)',
  aw_faa_cat_others: 'หมวดอื่น',
  aw_faa_cat_none_matching: 'ไม่มีหมวดใดบันทึกสินทรัพย์ใน {{code}} เพิ่มหมวดได้ที่หมวดสินทรัพย์ หรือกำหนดบัญชีสินทรัพย์เป็น {{code}} เอง',
  aw_faa_cat_account: 'ของหมวด: {{acct}}',
  aw_faa_capitalised_hint: 'ค่าขนส่ง ค่าติดตั้ง และต้นทุนอื่นที่บวกเพิ่มจากราคาซื้อ',
  aw_faa_start_hint: 'ว่างไว้ = วันที่พร้อมใช้งาน หรือวันที่ซื้อ',
  aw_faa_life_hint: 'อายุและอัตราเป็นค่าเดียวกัน: 5 ปี = 20% ต่อปี',
  aw_faa_ceiling: 'กฎหมายให้คิดได้สูงสุด {{max}}% ต่อปีสำหรับ {{cls}}',
  aw_faa_method_hint: 'ขณะนี้รองรับเฉพาะวิธีเส้นตรง',
  aw_faa_opening_hint: 'สำหรับสินทรัพย์ที่นำเข้าระหว่างอายุการใช้งาน: กรอกทั้งจำนวนเงินและวันที่ยกมา หรือไม่กรอกทั้งคู่',
  aw_faa_opening_both: 'ต้องกรอกทั้งจำนวนค่าเสื่อมสะสมยกมาและวันที่ — หรือไม่กรอกทั้งคู่',
  aw_faa_status_auto: 'คำนวณจากวันที่',
  aw_faa_status_hint: 'คิดค่าเสื่อมครบแล้ว จำหน่ายแล้ว และตัดจำหน่ายแล้ว คำนวณจากตัวเลข เลือกเองไม่ได้',
  aw_faa_accounts_hint: 'ใช้บัญชีของหมวด ถ้าเลือกบัญชีอื่นสำหรับสินทรัพย์นี้จะมีป้าย "กำหนดเอง"',
  aw_faa_src_title: 'ซื้อตามรายการค่าใช้จ่ายนี้',
  aw_faa_src_no: 'เลขที่ค่าใช้จ่าย',
  aw_faa_src_date: 'วันที่',
  aw_faa_src_pick: 'เลือก',
  aw_faa_src_line: 'บรรทัด',
  aw_faa_src_line_n: 'บรรทัดที่ {{n}}',
  aw_faa_src_desc: 'รายละเอียด',
  aw_faa_src_account: 'บัญชี',
  aw_faa_src_amount: 'จำนวนเงิน',
  aw_faa_src_registered: 'ลงทะเบียนแล้ว',
  aw_faa_src_remaining: 'คงเหลือ',
  aw_faa_src_hint: 'เลือกบรรทัดที่ซื้อสินทรัพย์นี้ การลงทะเบียนไม่สร้างรายการบัญชีใด — รายการซื้อคือการได้มาอยู่แล้ว',
  aw_faa_src_acct_differs: 'หมวดนี้บันทึกสินทรัพย์ใน {{have}} แต่การซื้อบันทึกต้นทุนใน {{code}} {{name}} — ทะเบียนจะปฏิเสธ โปรดเลือกหมวดที่บัญชีสินทรัพย์เป็น {{code}}',
  aw_faa_src_acct_hand: 'บัญชีสินทรัพย์กำหนดไว้เป็น {{have}} แต่การซื้อบันทึกต้นทุนใน {{code}} {{name}} — ทะเบียนจะปฏิเสธ โปรดกำหนดบัญชีสินทรัพย์เป็น {{code}}',
  aw_faa_src_acct_kept: 'ซื้อตามรายการค่าใช้จ่าย — สินทรัพย์ต้องอยู่ในบัญชีที่การซื้อบันทึกต้นทุนไว้',
  aw_faa_src_acct_moved: 'บรรทัดการซื้อตอนนี้บันทึกใน {{code}} {{name}} — เมื่อบันทึก สินทรัพย์จะย้ายจาก {{was}} ไปที่บัญชีนั้น เพื่อให้ทะเบียนตรงกับบัญชีแยกประเภท',
  aw_faa_src_cost_over: 'บรรทัดที่ {{n}} ของการซื้อมียอด {{amount}} เมื่อหักสินทรัพย์อื่นที่ซื้อในบรรทัดนี้แล้ว สินทรัพย์นี้มีต้นทุนได้ไม่เกิน {{max}}',
  aw_faa_src_line_gone: 'บรรทัดการซื้อของสินทรัพย์นี้ไม่มีอยู่แล้ว หรือไม่ได้บันทึกในบัญชีสินทรัพย์อีกต่อไป — ต้นทุนและบัญชีสินทรัพย์คงตามที่ลงทะเบียนไว้จนกว่าจะแก้ไขบิล',
};
